import React from 'react';

const LoadingButton = ({ isLoading, onClick, label = "Готово", color = "green" }) => {
  // Определяем цвета на основе параметра color
  const getColorClasses = () => {
    const colorMap = {
      green: "bg-green-500 hover:bg-green-600",
      blue: "bg-blue-500 hover:bg-blue-600",
      red: "bg-red-500 hover:bg-red-600",
      gray: "bg-gray-500 hover:bg-gray-600",
      purple: "bg-purple-500 hover:bg-purple-600"
    };
    
    return colorMap[color] || colorMap.green;
  };

  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className={`${getColorClasses()} text-white text-xs px-2 py-1 rounded transition-colors focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-${color}-500 disabled:opacity-50 whitespace-nowrap`}
    >
      {isLoading ? (
        <div className="flex items-center">
          <svg
            className="animate-spin -ml-1 mr-1.5 h-3 w-3 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          ...
        </div>
      ) : (
        label
      )}
    </button>
  );
};

export default LoadingButton;